import { BaseAppSettings, Connection } from "./models/appSettings";
import { Device, IConfiguration, path } from "@skoda/k2tools-app-services/lib";

export class AppConfig implements IConfiguration {

    private widget: boolean;
    private appSettings: BaseAppSettings;
    private connection: Connection;

    constructor(
        baseAppSettings: BaseAppSettings,
        connection: Connection,
        widget: boolean,
    ) {
        this.appSettings = baseAppSettings;
        this.connection = connection;
        this.widget = widget;
    }

    public get baseName() {
        return path(this.appSettings.webAppRoute, this.appSettings.bid, this.appSettings.culture);
    }

    public get historyBaseName() {
        return this.appSettings.isCustomDomain
            ? path(this.appSettings.webAppRoute)
            : path(this.appSettings.webAppRoute, this.appSettings.bid, this.appSettings.culture);
    }

    public get webAppRoute() {
        return this.appSettings.webAppRoute;
    }

    public get bid() {
        return this.appSettings.bid;
    }

    public get culture() {
        return this.appSettings.culture;
    }

    public get dealerId() {
        return this.appSettings.dealer;
    }

    public get apiUrl() {
        return this.connection.protocol + '//' + path(this.connection.host, this.baseName);
    }

    public get protocol() {
        return this.connection.protocol;
    }

    public get host() {
        return this.connection.host;
    }

    public GetResourceProviderApiUrl = () => {
        return path(this.connection.protocol, this.connection.host, this.baseName, "api/Resource/GetDataResources");
    }

    public TranslationNamespaces: any = {
        Default: 'Strings',
        WebApp: 'SkodaAuto.Marvin.K2Tools.Common.Resources',
        CodeList: 'SkodaAuto.Marvin.K2Tools.CodeList'
    };

    public get imgPath() {
        return (this.appSettings && this.appSettings.webAppRoute && this.appSettings.webAppRoute.length)
            ? this.connection.protocol + '//' + this.connection.host + '/' + this.appSettings.webAppRoute + '/Content/img/'
            : this.connection.protocol + '//' + this.connection.host + '/Content/img/';
    }

    public get Icons() {
        return {
            BannerShape: this.imgPath + 'shape.svg',
            BannerShapeMobile: this.imgPath + 'shape-mobile.svg',
            IconClose: this.imgPath + 'cross.svg',
            Arrow: this.imgPath + 'arrow.svg'
        };
    }

    public get isWidget() {
        return this.widget;
    }
}